<script setup lang="ts">
import { RouterView } from "vue-router";
import TopBar from "@/components/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";

const auth = useAuthStore();
const { role, loading } = storeToRefs(auth);
</script>

<template>
  <header>
    <TopBar />
  </header>
  <div class="page-container">
    <SideBar />
    <main class="page-content">
      <pn-toast
        text="Unauthorized"
        closable="false"
        appearance="error"
        v-show="!role && !loading"
      >
      </pn-toast>
      <RouterView v-show="role" />
    </main>
  </div>
</template>

<style lang="scss">
@import "@/assets/base.scss";
.page-container {
  display: flex;
}

.page-content {
  flex: 1;
  min-width: 0;
  padding: 40px;
  background-color: white;
  height: 100%;
  flex: 1;
  min-width: 0;
}
</style>
